import { render } from "./ModalCropImage.vue?vue&type=template&id=20b20a2f&scoped=true&ts=true"
import script from "./ModalCropImage.vue?vue&type=script&lang=ts"
export * from "./ModalCropImage.vue?vue&type=script&lang=ts"

import "./ModalCropImage.vue?vue&type=style&index=0&id=20b20a2f&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b20a2f"]])

export default __exports__